<div class="dashboard-print-overlay-container"  id="printable" #formDialog>
    <div *ngIf="!printableData?.length">
        <h3 style="text-align: center">{{'pendingAppointments.noAppointmentsFound' | translate }}</h3>
    </div>
    <div *ngIf="printableData?.length">
    <h3 style="text-align: center">{{'appointmentPrint.date' | translate}}: {{printableData[0].date}}</h3>
    <table aria-describedby="schedule-dashboard">
        <tr>
            <th  *ngIf="department === 'SALES'">{{'appointmentPrint.appointmentType' | translate}}</th>
            <th>{{'appointmentPrint.time' | translate}}</th>
            <th>{{'appointmentPrint.customerName' | translate}}</th>
            <th>{{'appointmentPrint.yrMakemodel' | translate}}</th>
            <th>{{'appointmentPrint.location' | translate}}</th>
            <th *ngIf="department !== 'SALES'">{{'appointmentPrint.opcode' | translate}}</th>
            <th *ngIf="department !== 'SALES'">{{'appointmentPrint.serviceDescription' | translate}}</th>
            <th>{{'appointmentPrint.apptDuration' | translate}}</th>
            <th *ngIf="department !== 'SALES'">{{'appointmentPrint.team' | translate}}</th>
            <th>{{department?.toUpperCase() === 'SERVICE' ? ('appointmentPrint.serviceAdvisor' | translate ) : ('appointmentPrint.salesAdvisor' | translate ) }} </th>
            <th>{{'appointmentPrint.appointmentCreationDate' | translate}}</th>
            <th>{{'appointmentPrint.appointmentCreatedBy' | translate}}</th>
        </tr>
        <tr *ngFor="let appointment of printableData">
            <td *ngIf="department === 'SALES'">{{appointment.appointmentType}}</td>
            <td [ngClass]="department === 'SALES' ? 'appt-time' : ''">{{appointment.time}}</td>
            <td>{{appointment.customerName}}</td>
            <td>{{appointment.makeModelYear}}</td>
            <td >{{(appointment.TransportOption) | translate}}</td>
            <td *ngIf="department !== 'SALES'" [innerHTML]="appointment.opCode"></td>
            <td *ngIf="department !== 'SALES'" class="service-desc">{{appointment.serviceDescription}}</td>
            <td>{{appointment.estimatedDuration}}</td>
            <td *ngIf="department !== 'SALES'">{{appointment.teamName}}</td>
            <td>{{appointment.advisorName}}</td>
            <td class="appt-date">{{appointment.appointmentCreationDate}}</td>
            <td>{{appointment.appointmentCreatedBy | translate}}</td>
        </tr>
    </table>
    </div>
</div>

<button #print printSectionId="printable" ngxPrint [useExistingCss]="true" [hidden]="true">print</button>